import { Directive, ElementRef, Input, HostListener } from '@angular/core';

@Directive({
  selector: '[selectTextOnFocus]'
})
export class SelectTextOnFocusDirective {

  @Input('focus') focus: boolean = true;

  private el: ElementRef;

  constructor(el: ElementRef) {
    this.el = el;
  }

  @HostListener('focus') onFocus() {
    var range = document.createRange();
    range.selectNodeContents(this.el.nativeElement);
    var sel = window.getSelection();
    sel.removeAllRanges();
    sel.addRange(range);
  }
}
